

import React, { useState } from 'react';
import '@ant-design/v5-patch-for-react-19';

import { Menu, Input, Slider, Checkbox , Select  } from 'antd';
import '../App.css';

export default function Filters({ onFilterChange }) {

  let baseURL = "https://apiv2.mobileartsme.com/searchDTShop_Content";

  // State for filters
  const [searchKey, setSearchKey] = useState('');
  const [priceValue, setPriceValue] = useState(null);
  const [selectedCountries, setSelectedCountries] = useState([]);
  const [selectedProductTypes, setSelectedProductTypes] = useState([]);
  const [ShowPriceFilter, setShowPriceFilter] = useState(false);

  const [searchTerm, setSearchTerm] = useState(''); // State for country search input

  // Handle search input change
  const onSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };



  // Popular countries list
  const popularCountries = [
    "Indonesia", "Guatemala", "Nigeria", "El Salvador", "South Africa", "Bangladesh",
    "Philippines", "Qatar", "Costa Rica", "Honduras", "Nicaragua", "Thailand",
    "Morocco", "Singapore", "United Arab Emirates", "Gambia", "Algeria", "Saudi Arabia",
    "Sri Lanka", "Egypt", "Turkey", "Russia", "China", "Vietnam", "Pakistan", "India",
    "Kazakhstan", "Laos", "Nepal", "Mexico", "Brazil", "Peru", "Malaysia", "Colombia",
    "United States", "Fiji", "Ghana", "Mozambique", "Dominican Republic", "Chile",
    "Poland", "Tanzania", "Haiti", "Jamaica", "Panama", "Ecuador", "Bolivia", "Benin",
    "Cameroon", "Republic of the Congo", "Ivory Coast", "Senegal", "Iraq", "DR Congo",
    "Palestine", "Tunisia", "Suriname", "Turks and Caicos Islands", "British Virgin Islands",
    "Madagascar", "Anguilla", "Antigua and Barbuda", "Dominica", "Grenada", "Montserrat",
    "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent and the Grenadines", "Barbados",
    "Cayman Islands", "Uruguay", "Guyana", "Kenya", "Afghanistan", "Cambodia", "Burundi",
    "Portugal", "Uganda", "Rwanda", "Romania", "Cyprus", "Mali", "Niger", "Liberia",
    "Trinidad and Tobago", "Guinea-Bissau", "France", "Guinea", "Paraguay", "Spain",
    "Puerto Rico", "Burkina Faso", "United Kingdom", "Central African Republic", "Argentina",
    "Albania", "Zambia", "Aruba", "Martinique", "Eswatini", "Togo", "Zimbabwe",
    "Caribbean Netherlands", "Kuwait", "Tonga", "Samoa", "Nauru", "Papua New Guinea",
    "Vanuatu", "Moldova", "Armenia", "Myanmar", "French Guiana", "Botswana", "Bahamas",
    "Kyrgyzstan", "Tajikistan", "Bermuda", "Jordan", "Belize", "Canada", "Georgia",
    "Germany", "Switzerland", "Belgium", "Netherlands", "Lithuania", "Ethiopia", "Namibia",
    "Kosovo", "Cape Verde", "Luxembourg", "Oman", "Italy", "Japan", "Malawi", "Greece",
    "Comoros", "Uzbekistan", "Azerbaijan", "Venezuela", "Bahrain", "Lebanon", "Reunion",
    "Somalia", "Mauritania", "Curacao", "Australia", "Ireland", "Czechia", "Sierra Leone",
    "Angola", "Chad", "Djibouti", "Equatorial Guinea", "Eritrea", "Gabon", "Lesotho",
    "Mauritius", "Seychelles", "Sudan", "Slovakia", "Estonia", "Austria", "Global",
    "Europe", "Andorra", "Bosnia and Herzegovina", "Brunei", "Bulgaria", "Croatia",
    "Denmark", "Finland", "Hong Kong", "Hungary", "Iceland", "South Korea", "Latvia",
    "Macau", "Malta", "Mongolia", "New Zealand", "Norway", "Slovenia", "Solomon Islands",
    "Sweden", "Ukraine", "Yemen", "Bhutan", "Belarus", "Faroe Islands", "Gibraltar",
    "Greenland", "Guadeloupe", "Iran", "Liechtenstein", "Montenegro", "North Macedonia",
    "Serbia", "Taiwan", "South Sudan", "Asia"
  ];


  // Available product types
  const productTypes = ["Gift Cards", "Mobile", "Utilities", "eSIM"];

  // Filter countries based on search input
  const filteredCountries = popularCountries.filter(country =>
    country.toLowerCase().includes(searchTerm.toLowerCase())
  );


  // Handle price range change
  const onPriceChange = (value) => {
    console.log(value)
    setPriceValue(value);  // Take max value since API needs one value
    updateFilters({ priceValue: value});
  };

  // Handle country selection
  const onCountryChange = (country, checked) => {
    const updatedCountries = checked
      ? [...selectedCountries, country]
      : selectedCountries.filter(c => c !== country);

    setSelectedCountries(updatedCountries);
    updateFilters({ countries: updatedCountries });
  };

  // Handle product type selection
  const onProductTypeChange = (type, checked) => {
    setShowPriceFilter(true)

    const updatedTypes = checked
      ? [...selectedProductTypes, type]
      : selectedProductTypes.filter(t => t !== type);

    setSelectedProductTypes(updatedTypes);
    console.log(updatedTypes)
    updateFilters({ productTypes: updatedTypes });
  };








  
  // Function to construct API query parameters dynamically
  const updateFilters = (updatedFilter) => {
    const filters = {
      searchKey,
      priceValue,
      countries: selectedCountries,
      productTypes: selectedProductTypes,
      ...updatedFilter
    };
  
    // Store filters in sessionStorage
    sessionStorage.setItem("filters", JSON.stringify(filters));
  
    // Build query parameters
    let params = new URLSearchParams();
    if (filters.searchKey) params.append("searchKey", filters.searchKey);
    if (filters.priceValue) params.append("priceValue", filters.priceValue);
    if (filters.countries.length) params.append("country", filters.countries.join(","));
    if (filters.productTypes.length) params.append("productType", filters.productTypes.join(","));
  
    const apiEndpoint = `${baseURL}?${params.toString()}`;
  
    onFilterChange(apiEndpoint);
  };
  


  const priceOptions = [
    { value: 10, label: 'Up to $10' },
    { value: 30, label: 'Up to $30' },
    { value: 60, label: 'Up to $60' },
    { value: 100, label: 'Up to $100' },
    { value: 500, label: 'Up to $500' },
  ];



  const clearFilters = () => {
    sessionStorage.removeItem("filters");
  
    // Reset filter values
    setSearchKey("");
    setPriceValue("");
    setSelectedCountries([]);
    setSelectedProductTypes([]);
  
    window.location.reload();
  };


    
  const items = [
    {
      key: 'sub1',
      label: 'Filter By Category',
      children: productTypes.map((type, index) => ({
        key: `type_${index}`,
        label: (
          <Checkbox
            checked={selectedProductTypes.includes(type)}
            onChange={(e) => onProductTypeChange(type, e.target.checked)}
          >
            {type}
          </Checkbox>
        ),
      })),
    },
    ...(ShowPriceFilter
      ? [
          {
            key: 'sub2',
            label: 'Filter By Price',
            children: [
              {
                key: 'price_range',
                label: (
                  <Select
                    placeholder="Select max price"
                    style={{ width: '100%' }}
                    options={priceOptions}
                    value={priceValue}
                    onChange={onPriceChange}
                  />
                ),
              },
            ],
          },
        ]
      : ""),
    {
      key: 'sub3',
      label: 'Filter By Country',
      children: [
        {
          key: 'search_input',
          label: <Input
            placeholder="Search Country"
            value={searchTerm}
            onChange={onSearchChange}
          />,
        },
        ...filteredCountries.map((country, index) => ({
          key: `country_${index}`,
          label: (
            <Checkbox
              checked={selectedCountries.includes(country)}
              onChange={(e) => onCountryChange(country, e.target.checked)}
            >
              {country}
            </Checkbox>
          ),
        })),
      ],
    },
  ];

  return (
    <div>
      <button data-aos="fade-down"  className='my-1'
      style={{float:'right' , background:'none' , border:'none' , fontSize:'1.2rem' }} onClick={clearFilters}>Clear Filters</button>
    <Menu
    
      data-aos="fade-down"
      className='filter_menu bg_grey_light p-2 br_15 d-flex flex-column gap-3'
      mode="inline"
      items={items} 
    /> 
    </div>
  );
}
